module.exports = __webpack_public_path__ + "static/img/Sex.dbaa983.png";